import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { PROCESS_STEPS } from "../content/siteContent";
import { locProcess } from "../content/i18n_extra";
import { KanjiWatermark } from "./JapaneseMotifs";

export function Process() {
  const { t, lang } = useLang();

  return (
    <section id="surec" className="relative bg-white py-28 sm:py-36 overflow-hidden" data-testid="process-section">
      <KanjiWatermark text="旅" className="left-2 bottom-8 text-[11rem] hidden lg:block" />
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <div className="text-xs font-heading font-bold tracking-[0.18em] sm:tracking-[0.3em] uppercase text-brand mb-4">{t("sec_process_kicker")}</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-ink text-balance max-w-2xl">{t("sec_process_title")}</h2>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROCESS_STEPS.map((s, i) => {
            const c = locProcess(s, i, lang);
            return (
              <motion.div
                key={s.no}
                data-testid={`process-step-${s.no}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
                className="relative bg-ice rounded-3xl border border-brand/10 p-8 pt-10 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-brand/10 transition-[transform,box-shadow] duration-300"
              >
                <span className="absolute -top-5 left-8 font-heading text-[64px] leading-none font-bold text-brand/15 select-none">{s.no}</span>
                <h3 className="relative font-heading text-lg font-bold text-ink mt-3">{c.t}</h3>
                <p className="relative mt-2.5 text-sm text-ink/60 leading-relaxed">{c.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
